/**
 * External dependencies
 */

/**
 * React dependencies
 */

import React from 'react';

/**
 * DWT dependencies
 */

import useViewportHeight from '../../hooks/useViewportHeight';
import useApiFilterData from './providers/useApiFilterData';
import useContextFilterData from './providers/useContextFilterData';
import useFilterManager from './hooks/useFilterManager';

/**
 * DWT components
 */

import FilterRenderer from './FilterRenderer';

/**
 * Filter
 *
 * Filter component
 *
 * @param {Object} props
 * @param {string} props.context
 * @param {number} props.recordCount
 * @param {Object} props.setStart
 * @param {boolean} props.error
 */
const FilterContainer = ({ context, filterType, recordCount, setStart, error }) => {
  useViewportHeight();

  const isTeamMemberGrid = context?.gridId;

  // Choose data 
  const data = isTeamMemberGrid ? useContextFilterData() : useApiFilterData( context );

  // Handle UI 
  const manager = useFilterManager(
    filterType,
    context, 
    data.currentPostType, 
    data.resetAllContextFilters
  );

  return (
    <FilterRenderer 
      filterType={ filterType }
      data={ data }
      manager={ manager }
      context={ context }
      recordCount={ recordCount }
      error={ error }
      setStart={ setStart }
    />
  );
};

export default FilterContainer;
